var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    enableBackground: "new 0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFC638",
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0D6B45",
    d: "M362.7,358.6H37.3V72.7c0-6.4,5.2-11.6,11.6-11.6h302.2c6.4,0,11.6,5.2,11.6,11.6V358.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101834",
    d: "M362.7,85.2H37.3V72.7C37.3,66.3,42.5,61,49,61H351c6.5,0,11.7,5.2,11.7,11.7V85.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF403D",
    cx: 55.7,
    cy: 73.8,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC738",
    cx: 71.8,
    cy: 73.8,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00DB91",
    cx: 87.9,
    cy: 73.8,
    r: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.7,127.1h256.6c2.2,0,4,1.8,4,4v175c0,2.2-1.8,4-4,4H71.7c-2.2,0-4-1.8-4-4v-175 C67.7,128.9,69.5,127.1,71.7,127.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 214.8,
    transform: "matrix(3.558837e-14 -1 1 3.558837e-14 -78.1533 387.5783)",
    fill: "#FF80AB",
    width: 51.5,
    height: 36.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.3,
    y: 203.9,
    transform: "matrix(2.493023e-14 -1 1 2.493023e-14 -21.9105 421.9105)",
    fill: "#FFB9D0",
    width: 73.4,
    height: 36.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.3,
    y: 222.5,
    transform: "matrix(5.068740e-14 -1 1 5.068740e-14 4.7215 485.8535)",
    fill: "#FF403D",
    width: 36.1,
    height: 36.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#196CFF",
    cx: 317.5,
    cy: 295.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#196CFF",
    cx: 305.5,
    cy: 295.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#196CFF",
    cx: 293.5,
    cy: 295.1,
    r: 4.6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#196CFF",
    d: "M275.2,149.8H85.9c-2.2,0-4-1.8-4-4v-1c0-2.2,1.8-4,4-4h189.3c2.2,0,4,1.8,4,4v1 C279.2,148,277.4,149.8,275.2,149.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#196CFF",
    cx: 311,
    cy: 145.3,
    r: 11.2
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.f3317ca99ac31e50c2cbd8403caa09ac.svg";
export { ForwardRef as ReactComponent };